import { HttpClient } from '../http-client';
import { PermissionSetDefinitionsLight } from './types';

export class PermissionHttpClient extends HttpClient {
  public getPermissionSetDefinitionsLight = async (): Promise<
    Array<PermissionSetDefinitionsLight>
  > => {
    return this.get<Array<PermissionSetDefinitionsLight>>(
      '/permission-set/get-definition-light',
    );
  };
}
